import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/opt/carify/website/layouts/default.vue").then(m => m.default || m)),
  footless: defineAsyncComponent(() => import("/opt/carify/website/layouts/footless.vue").then(m => m.default || m)),
  frameless: defineAsyncComponent(() => import("/opt/carify/website/layouts/frameless.vue").then(m => m.default || m))
}